import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../../auth/service/utils.service";
import recruitmentMenu from "../recruitment.menu";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import bargainingRoutes from "./bargaining.routes";
import { locale as bargainingIt } from "./i18n/bargaining.lang-it";
import { LayoutModule } from "../../../layout/layout.module";
import { CoreCardModule } from "../../../../@core/components/core-card/core-card.module";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { NgbDropdownModule, NgbTimepickerModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { CreateBargainingComponent } from "./pages/create/create-bargaining.component";
import { EditBargainingComponent } from "./pages/edit/edit-bargaining.component";
import { BargainingListComponent } from "./pages/list/bargaining-list.component";
import { SelectBargainingComponent } from "./pages/select/select-bargaining.component";
import { BreadcrumbModule } from "../../../layout/components/content-header/breadcrumb/breadcrumb.module";
import { DragDropModule } from "@angular/cdk/drag-drop";

import { CompanyOfficeListComponent } from "./pages/company-office-list/company-office-list.component";

@NgModule({
  declarations: [CreateBargainingComponent, EditBargainingComponent, BargainingListComponent, SelectBargainingComponent, CompanyOfficeListComponent],
  imports: [
    RouterModule.forChild(bargainingRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    LayoutModule,
    CoreCardModule,
    AngularEditorModule,
    NgbTooltipModule,
    NgbDropdownModule,
    BreadcrumbModule,
    DragDropModule,
    NgbTimepickerModule,
  ],
})
export class BargainingModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("bargaining", bargainingIt, recruitmentMenu, []);
  }
}
